/* eslint-disable react/jsx-filename-extension */
import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import { Col, Row } from 'grab-ui';
import { Radio, Alert } from '@duxton-web/ui';
import { getRequestStateKey } from 'omega-rtc/utils/ucd-utils';
import { MoreInfoFilled } from '@duxton-web/icons';
import { GET_LIST_RULE_TYPE, getListRuleTypes } from 'omega-rtc/actions/newTridentExtra';
import JOURNEY_TEMPLATE_KEY_DATA from 'omega-rtc/components/journey-builder/utils/constants';
import JourneyDiagram from 'omega-rtc/components/journey-builder/Diagram';
import './JourneyPage.scss';

type Props = {
  isView: boolean,
};

type State = {
  reminderTemplateKey: PreDefinedTemplate,
  handleTemplateChange: Function,
}

export class JourneyPage extends React.Component {
  props: Props;
  state: State;

  constructor(props: Props) {
    super(props);
    this.state = {
      reminderTemplateKey: 'reminder',
    };
  }

  componentDidMount() {
    this.props.handleTemplateChange(this.state.reminderTemplateKey);
  }

  handleDefaultTemplateChange = (e) => {
    const key = _.get(e, 'target.value');
    this.setState({
      reminderTemplateKey: key,
    });
    this.props.handleTemplateChange(key);
  };

  render() {
    const { reminderTemplateKey } = this.state;
    return (<React.Fragment>
      <div className={'jb-select-template'}>
        <Row>
          <Col><b className="title">Select Journey Template</b></Col>
        </Row>
        <Row>
          <Col>
            <Radio.Group onChange={this.handleDefaultTemplateChange} defaultValue="reminder" buttonStyle="solid">
              <Radio.Button value={'reminder'}>
                <div className="predefined-template">
                  <b>Regular Reminder</b>
                  <span>Remind the user with follow-up messages after delay</span>
                </div>
              </Radio.Button>
              <Radio.Button value={'adaptive'}>
                <div className="predefined-template">
                  <b>Selective Reminder</b>
                  <span>Only remind the user who didn’t open the 1st message</span>
                </div>
              </Radio.Button>
            </Radio.Group>
          </Col>
        </Row>
        <Row>
          <Col><Alert
            message={
              <div>
                <div>
                  <MoreInfoFilled />
                </div>
                <div style={{ marginLeft: 8 }}>
                  <b> More template coming soon</b>
                  <br />
                    We will add more templates based on common use cases. Please stay tuned!
                </div>
                <div>
                  <a rel="">Give suggestion</a>
                </div>
              </div>
            } type="info"
          /></Col>
        </Row>
        <Row style={{ minHeight: 400 }}>
          <Col span={24}>
            <JourneyDiagram isView data={JOURNEY_TEMPLATE_KEY_DATA[reminderTemplateKey]} />
          </Col>
        </Row>
      </div>
    </React.Fragment>);
  }
}

const mapStateToProps = (state) => {
  return {
    getListRuleTypesRequest: _.get(
      state.requests,
      getRequestStateKey(GET_LIST_RULE_TYPE),
      {},
    ),
  };
};

const mapDispatchToProps = dispatch => ({
  getListRuleTypes: (owner, targetUserType) => {
    dispatch(getListRuleTypes({ owner, targetUserType }));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(JourneyPage);
